import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, message, Button, Input, Select } from 'antd';
import { isEmpty } from 'utils/utils';
import moment from 'moment';
import { IMaskInput } from "react-imask";

export interface CompanyCashModalProps extends PopupProps {
    id: number;
    cash_type?: string;
    cash_gubun?: string;
    cash?: number;
    created_at?: string;
    memo?: string;
    totalcash?: number;
}

const CompanyCashEditModal = ({ isOpen, onClose, id, cash_type, cash_gubun, cash, created_at, memo, totalcash = 0 }: CompanyCashModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [isFormDone, setIsFormDone] = useState<boolean>(false);
   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();
  const { TextArea } = Input;

  const configBlocks = {
    PriceInput: {
      mask: Number,
      signed: true,  // disallow negative
      thousandsSeparator: ",",  // any single char
      padFractionalZeros: false,
      normalizeZeros: false,
      unmask: true // true|false|'typed'
    }
  }  
   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onSubmit = (e) => {
        if (!validateRegistrant())  return;
        
        onClose?.(true, e.cash_gubun, Number(form.getFieldValue('cash').toString().replaceAll(',','')) | 0, e.memo);
      };

    const onChangeForm = () => { 
        setIsFormDone(!(isEmpty(form.getFieldValue('cash_gubun')) || isEmpty(form.getFieldValue('cash')) || form.getFieldValue('cash') === '0' || isEmpty(form.getFieldValue('memo'))));
    };      
    /* ======================================================
    * methods
    * ====================================================== */
    
    const validateRegistrant = () => {
        if (form.getFieldValue('cash_gubun') === 'OUT') {
            if (form.getFieldValue('cash') > totalcash) {
                message.error("보유한 금액 이상은 차감 할 수 없습니다.", 1);
                return false;                
            }
        };   
        return true;        
    }

  /* ======================================================
   * effects
   * ====================================================== */

    useEffect(() => {
        form.setFieldsValue({
            cash_gubun: cash_gubun || '',
            cash: cash || 0,
            created_at: created_at || moment().format('YYYY-MM-DD HH:mm:ss'),
            memo: memo || '',
        });


    }, []);

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={400} title={'고객사 ' + (cash_type==='POINT'?'포인트 ':'선납금 ') + (id===0?'등록':' 정보')} closable>
            <Form
                form={form}
                name="CompanyCash"
                layout="horizontal"  
                labelCol={{ flex: '100px' }}
                onFieldsChange={onChangeForm}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item name="cash_gubun" label={'등록구분'} rules={[{ required: true, message: '' }]}>
                    <Select disabled={id>0}>
                        <Select.Option value="IN">입금</Select.Option>
                        <Select.Option value="OUT">차감</Select.Option>
                    </Select>                  
                </Form.Item>     
                <Form.Item name="cash" label={cash_type==='POINT'?'포인트':'선납금'} rules={[{ required: true, message: '' }]}>
                    <IMaskInput disabled={id>0} placeholder={cash_type==='POINT'?'포인트를 입력하세요':'선납금을 입력하세요'} blocks = {configBlocks} mask = "PriceInput" className={'ant-input'} unmask={'typed'} onAccept = {((value, mask) => {form.setFieldValue('cash', value);})}/>
                </Form.Item>  
                <Form.Item name="created_at" label={'등록일'}>
                    <Input type="text" disabled={true}/>                                                                           
                </Form.Item>   
                <Form.Item name="memo" label="메모" rules={[{ required: true, message: '' }]}>
                    <TextArea rows={3} placeholder='메모를 입력하세요'/>   
                </Form.Item>  
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <Button htmlType="submit"  type="primary" disabled={!isFormDone}>{id===0 ? '등록' : '수정'}</Button>
                </ButtonGroup>
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(CompanyCashEditModal); 